import React from "react";
import SharedDonut from "../../common/DonutChart";
import NoData from "../../common/NoData";
import { BRAND, STATUS_COLORS, getPaletteColor } from "../../../utils/chartTheme";

const VERIFICATION_COLORS = {
  pmApproved: BRAND.teal,
  pmRejected: getPaletteColor(2),
  pmPending: STATUS_COLORS.planned,
  dqaApproved: BRAND.tealLight,
  dqaRejected: getPaletteColor(5),
  dqaPending: "#D1D5DB",
};

const DonutChart = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    { name: "PM Approved", value: 0, color: VERIFICATION_COLORS.pmApproved }, 
    { name: "PM Rejected", value: 0, color: VERIFICATION_COLORS.pmRejected }, 
    { name: "PM Pending", value: 0, color: VERIFICATION_COLORS.pmPending },
    { name: "DQA Approved", value: 0, color: VERIFICATION_COLORS.dqaApproved }, 
    { name: "DQA Rejected", value: 0, color: VERIFICATION_COLORS.dqaRejected }, 
    { name: "DQA Pending", value: 0, color: VERIFICATION_COLORS.dqaPending },
  ];

  if (data && data.length > 0) {
    data.forEach((item) => {
      const existingIndex = allStatusData.findIndex(
        (status) => status.name === item.name
      );
      if (existingIndex !== -1) {
        allStatusData[existingIndex].value = item.value;
      }
    });
  }

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};

const DonutChartWithSideData = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    { name: "PM Approved", value: 0, color: VERIFICATION_COLORS.pmApproved },
    { name: "PM Rejected", value: 0, color: VERIFICATION_COLORS.pmRejected },
    { name: "PM Pending", value: 0, color: VERIFICATION_COLORS.pmPending },
    { name: "DQA Approved", value: 0, color: VERIFICATION_COLORS.dqaApproved },
    { name: "DQA Rejected", value: 0, color: VERIFICATION_COLORS.dqaRejected },
    { name: "DQA Pending", value: 0, color: VERIFICATION_COLORS.dqaPending },
  ];

  if (data && data.length > 0) {
    data.forEach((item) => {
      const existingIndex = allStatusData.findIndex(
        (status) => status.name === item.name
      );
      if (existingIndex !== -1) {
        allStatusData[existingIndex].value = item.value;
      }
    });
  }

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};
const CompactDonutChart = ({ data, centerValue, centerLabel }) => {
  const allStatusData = [
    { name: "Completed", value: 0, color: STATUS_COLORS.completed }, 
    { name: "In Progress", value: 0, color: STATUS_COLORS.underConstruction }, 
    { name: "Cancelled / Excluded", value: 0, color: getPaletteColor(2) }, 
  ];

  if (data && data.length > 0) {
    data.forEach((item) => {
      const existingIndex = allStatusData.findIndex(
        (status) => status.name === item.name
      );
      if (existingIndex !== -1) {
        allStatusData[existingIndex].value = item.value;
      }
    });
  }

  return (
    <SharedDonut
      items={allStatusData}
      centerValue={typeof centerValue === "number" ? centerValue : undefined}
      centerLabel={centerLabel}
    />
  );
};
const VerificationStatus = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg  shadow-sm animate-pulse">
        {" "}
        <div className="h-4 bg-gray-300 rounded w-1/3 mb-3"></div>{" "}
        <div className="h-48 bg-gray-200 rounded"></div>
      </div>
    );
  }
  const verificationData = [
    {
      name: "PM Approved",
      value: data?.pmVerification?.approved || 0,
      color: VERIFICATION_COLORS.pmApproved,
    },
    {
      name: "PM Rejected",
      value: data?.pmVerification?.rejected || 0,
      color: VERIFICATION_COLORS.pmRejected,
    },
    {
      name: "PM Pending",
      value: data?.pmVerification?.pending || 0,
      color: VERIFICATION_COLORS.pmPending,
    },
    {
      name: "DQA Approved",
      value: data?.dqaVerification?.approved || 0,
      color: VERIFICATION_COLORS.dqaApproved,
    },
    {
      name: "DQA Rejected",
      value: data?.dqaVerification?.rejected || 0,
      color: VERIFICATION_COLORS.dqaRejected,
    },
    {
      name: "DQA Pending",
      value: data?.dqaVerification?.pending || 0,
      color: VERIFICATION_COLORS.dqaPending,
    },
  ];

  const totalVerifications = verificationData.reduce(
    (sum, item) => sum + item.value,
    0
  );
  if (!totalVerifications) return <NoData />;

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      {" "}
      <DonutChartWithSideData
        data={verificationData}
        centerValue={totalVerifications.toString()}
        centerLabel="Total"
      />
    </div>
  );
};

export default VerificationStatus;
export { DonutChart, DonutChartWithSideData, CompactDonutChart };
